import requestExport from './request-export';

const extraReducers = {
  requestExport,
};

export default extraReducers;
